module.exports = __webpack_public_path__ + "static/parp-13ce27a6b22c189833ecc64d9c11dc4e.mp4";